import React, { useEffect, useState } from "react";
import {
  IndexChartWidget,
  ThemeType,
  WidgetError,
  WidgetHeightMessage,
  WidgetMessage,
  WidgetNameSource,
} from "@labci/bell-fg-widgets";
import { CHART_BUNDLE_URL } from "../utils/chartBundleUrl";
import { Spin } from "antd";
import CircularProgress from "../Components/CircularProgress/CircularProgress";

const IndexChart: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token") || "";
  const [symbol, setSymbol] = useState(queryParams.get("symbol") || "");
  const theme = queryParams.get("theme") || ThemeType.Direct;

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      console.log("message", event);
      if (event.data && event.data.type === "ric") {
        setSymbol(event.data.data?.ric || event.data.data?.symbol || "");
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(error),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };

  const handleLoadingChange = (loading: boolean) => {
    setIsLoading(loading);

    const loadingMessage = {
      type: "loading",
      value: loading,
      source: WidgetNameSource.IndexChart,
    };
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(loadingMessage),
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(loadingMessage), "*");
  };

  const handleNoData = (message: WidgetMessage) => {
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(message),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleHeightChange = (message: WidgetHeightMessage) => {
    console.log("handleHeightChange", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(message),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  return (
    <Spin
      wrapperClassName="widget-spin"
      spinning={isLoading}
      indicator={<CircularProgress theme={theme as ThemeType} />}
    >
      <IndexChartWidget
        symbol={symbol}
        token={token}
        theme={theme as ThemeType}
        chartBundleUrl={CHART_BUNDLE_URL}
        onError={handleError}
        onNoData={handleNoData}
        onLoadingChange={handleLoadingChange}
        onHeightChange={handleHeightChange}
      />
    </Spin>
  );
};

export default IndexChart;
